import React, { Component } from "react";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import { Row } from "react-foundation";

import { getWindowStyles } from "actions";
import Tick from "components/Tick";
import Loading from "components/Loading";

import validate from "./validate";

import Image from "components/Image";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";
import SlickSlider from "../../components/SlickSlider";
import { updatePreviousSelection } from "../../actions";

class SelectStyle extends Component {
    renderImage(value, index) {
        return (
            <div key={index}>
                <div className="slick-slide-image-container">
                    <Tick />
                    <Image src={value.externalImageUrl} alt="" className="slick-slide-image" />
                </div>
                <p className={"slick-slide-title"}>{value.name}</p>
                <p className={"slick-slide-subtitle show"}>{value.notes}</p>
            </div>
        );
    }

    render() {
        let { styles, input } = this.props;

        if (styles.length === 0) {
            return <Loading />;
        }

        return (
            <div>
                <Row isColumn style={{ maxWidth: 800, margin: "auto" }}>
                    <SlickSlider
                        values={styles}
                        selectedId={input.value}
                        onDisplay={this.renderImage.bind(this)}
                        onChange={id => input.onChange(id)}
                    />
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class StyleForm extends Component {
    componentDidMount() {
        // let itemTypeId = 1; // window

        this.props.getWindowStyles();
    }

    componentDidUpdate() {
        let { selectedStyle, styles, dispatch, previousSelection } = this.props;

        if (!selectedStyle.id) {
            if (styles.length > 0) {
                // do something
                dispatch(
                    change(
                        "WindowWizard",
                        "WindowStyleId",
                        previousSelection.WindowStyleId || styles[0].id
                    )
                );
            }
        }
    }

    onSubmit(values) {
        this.props.updatePreviousSelection({
            WindowStyleId: values.WindowStyleId
        });

        this.props.onSubmit(values);
    }

    render() {
        return (
            <form
                className="StyleForm"
                onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}
            >
                <FormHeader title={"Pick your style"} subtitle={""} />

                <SeparatingLine />

                <FormWrapper>
                    <Field
                        name="WindowStyleId"
                        component={SelectStyle}
                        styles={this.props.styles}
                    />
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("WindowWizard");
    let windowStyleId = valueSelector(state, "WindowStyleId");
    let selectedStyle = state.Window.Styles.filter(c => c.id === windowStyleId)[0] || {};

    return {
        styles: state.Window.Styles,
        selectedStyle,
        previousSelection: state.PreviousSelection
    };
};

export default connect(
    mapStateToProps,
    { getWindowStyles, updatePreviousSelection }
)(
    reduxForm({
        form: "WindowWizard",
        destroyOnUnmount: false,
        keepDirtyOnReinitialize: true,
        enableReinitialize: true,
        validate
    })(StyleForm)
);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/StyleForm.js